import { PaddedContainer, genClassName } from "@disco/disco_core";
import React, { useCallback, useRef } from "react";
import Slider from "react-slick";
import useData from "../../hooks/useData";
import LeadGenBrand from "./LeadGenBrand";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./lead-gen-carousel.css";
import useDimensions from "../../hooks/useDimensions";
import usePing, { PING_TYPES } from "../../hooks/usePing";

const LeadGenCarousel = ({
	currIdx = 0,
	onNext,
	onPrev,
	hPadding = 0,
	className = "",

	setIsInEngagement,

	claimOffer,
	claimedOffers,
	...props
} = {}) => {
	const internalIdx = useRef(currIdx);
	const sliderRef = useRef();
	const { brands } = useData();
	const { isLargeWidget } = useDimensions();

	const goToNextSlide = useCallback(() => {
		if (!sliderRef?.current) return;
		sliderRef.current.slickNext();
	}, []);

	const goToPrevSlide = useCallback(() => {
		if (!sliderRef?.current) return;
		sliderRef.current.slickPrev();
	}, []);

	const goToSlideIdx = useCallback((targetIdx) => {
		if (!sliderRef.current) return;
		sliderRef.current.slickGoTo(Number(targetIdx));
	}, []);

	usePing({
		key: PING_TYPES.LEAD_GEN_CAROUSEL_NEXT,
		callback: goToNextSlide,
	});
	usePing({
		key: PING_TYPES.LEAD_GEN_CAROUSEL_PREV,
		callback: goToPrevSlide,
	});
	usePing({
		key: PING_TYPES.LEAD_GEN_CAROUSEL_JUMP_IDX,
		callback: goToSlideIdx,
	});

	const handleBeforeChange = (current, next) => {
		const extrapolatedIdx = Math.floor(next + 0.5);
		internalIdx.current = extrapolatedIdx;
		if (typeof setIsInEngagement === "function") setIsInEngagement(true);
		const shouldCallParentHandler = currIdx !== extrapolatedIdx;
		if (
			next > current &&
			shouldCallParentHandler &&
			typeof onNext === "function"
		)
			onNext();
		if (
			next < current &&
			shouldCallParentHandler &&
			typeof onPrev === "function"
		)
			onPrev();
	};

	const handleAfterChange = () => {
		if (typeof setIsInEngagement === "function") setIsInEngagement(false);
	};

	const CAROUSEL_CONFIG = {
		speed: 500,
		infinite: false,
		slidesToShow: 1.2,
		slidesToScroll: 1,
		className: "lead-gen-carousel-slide slider variable-width",
		slide: "section",
		centerPadding: `${hPadding}px`,
		centerMode: true,
		draggable: !isLargeWidget,
		beforeChange: handleBeforeChange,
		afterChange: handleAfterChange,
	};
	return (
		<PaddedContainer
			className={genClassName({
				base: "lead-gen-carousel",
				conditionals: {
					"lead-gen-carousel-lg": isLargeWidget,
				},
				additional: className,
			})}
			{...props}
		>
			<Slider ref={sliderRef} {...CAROUSEL_CONFIG}>
				{brands.map((brand, idx) => (
					<LeadGenBrand
						brand={brand}
						idx={idx}
						activeIdx={currIdx}
						key={brand?.id}
						claimOffer={claimOffer}
						claimedOffers={claimedOffers}
						isLastBrand={idx === brands.length - 1}
					/>
				))}
			</Slider>
		</PaddedContainer>
	);
};

export default LeadGenCarousel;
